<script>
  import { onMount, onDestroy } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recsStore = getGroupStore('recsStore');
  import ComponentEvents from '@utils/component-events';
  import ScrollSpy from '@utils/scrollspy';

  import jQuery from 'jquery';

  let group = groupStore;
  let sections = sectionsStore;
  let recs = recsStore;
  let currentSection;
  let unsubCurrentSection;
  let showModal = false;
  let showSectionBar = false;
  let scrollUpdatesEnabled = true;
  let firstSectionTop;

  export let mobile = false;

  export let parentSelector;
  export let firstSectionPxBuffer = 0;

  let unsubGroup = group.subscribe((x) => (group = x));
  let unsubSections = sectionsStore.subscribe((x) => (sections = x));
  let unsubRecs = recsStore.subscribe((x) => (recs = x));

  let close = function () {
    showModal = false;
  };

  let show = function () {
    showModal = true;
  };

  let toggleSectionMenu = function () {
    if (showModal) {
      close();
    } else {
      show();
    }
  };

  let scrollToSection = function (section) {
    let elem = jQuery(`#ui-section-${section.id}`).parent().find('.ui-section-name');

    jQuery('.ui-section').css('opacity', 0);
    let maxIntervals = 50;
    let matchCount = 0;
    let intervals = 0;
    let sp = jQuery(parentSelector).scrollTop();

    let int = setInterval(function () {
      const parent = jQuery(parentSelector);

      const sectionBarHeight = jQuery('.column-current-section').outerHeight(true) || 0;
      const sectionOffset = sectionBarHeight * 1.1;

      // We want to scroll so that the "elem" is at the top of the "parent",
      // with an offset of sectionOffset.
      const adjustScrollBy = elem.offset().top - parent.offset().top - sectionOffset;

      parent.scrollTop(parent.scrollTop() + adjustScrollBy);

      const newSP = jQuery(parentSelector).scrollTop();

      if (intervals >= maxIntervals) {
        return clearInterval(int);
      }
      if (newSP != sp) {
        sp = newSP;
      } else {
        jQuery('.ui-section').css('opacity', 1);
        matchCount += 1;
        if (matchCount >= 5) {
          clearInterval(int);
        }
      }
      intervals += 1;
    }, 50);
  };

  let maxTop = function () {
    if (firstSectionTop) {
      return firstSectionTop;
    } else {
      try {
        const _firstSectionTop = document.querySelector('.ui-section').offsetTop;
        firstSectionTop = _firstSectionTop - firstSectionPxBuffer;
      } catch {
        firstSectionTop = 0;
      }
      return firstSectionTop;
    }
  };

  let showAndHideSectionBar = function (top) {
    if (top >= maxTop()) {
      showSectionBar = true;
    } else {
      showSectionBar = false;
    }
  };

  let setStyleForCurrentSectionModal = function (node) {
    const dropdown = jQuery('.column-current-section');
    const { top: dropdownTop, left: dropdownLeft } = dropdown.offset();
    const container = jQuery(node).closest('.modal__container');
    const content = container.find('.modal__content');
    const overlay = jQuery('.modal__overlay');

    container.attr(
      'style',
      [
        container.attr('style'),
        `margin-top: ${0}px !important`,
        `top: ${dropdownTop}px !important`,
        `left: ${dropdownLeft - 10}px !important`,
        `padding-top: 14px !important`,
        `width: 352px !important`,
        `box-shadow: 0px 4px 14px rgb(0 0 0 / 8%)`,
      ].join('; ')
    );

    content.attr('style', [content.attr('style'), `margin-top: 0px !important`].join('; '));

    overlay.attr('style', [overlay.attr('style'), `background-color: rgba(0,0,0,0.1) !important`].join('; '));
  };

  let setCurrentSection = function (section) {
    currentSection = section;
  };

  let unsubScrollToSection = ComponentEvents.on('mobile-scroll-to-section', scrollToSection);

  let removeScrollSpy;

  const setupScrollSpy = () => {
    ScrollSpy.setup('column-current-section', '.map-view__recs-column', true);
    removeScrollSpy = ScrollSpy.on('column-current-section', (data) => {
      if (data && data.section) {
        ComponentEvents.trigger('current-section', data);
      }
    });
  };

  let unsubCurrentSectionComponentEvent;
  const setupCurrentSectionComponentEvent = () => {
    unsubCurrentSectionComponentEvent = ComponentEvents.on('current-section', async (data) => {
      if (scrollUpdatesEnabled && data && data.section) {
        setCurrentSection(data.section);
      }
    });
  };

  onMount(() => {
    jQuery(parentSelector).scroll(function () {
      const top = jQuery(parentSelector).scrollTop();
      showAndHideSectionBar(top);
    });
    setupScrollSpy();
    setupCurrentSectionComponentEvent();
  });

  onDestroy(() => {
    unsubGroup();
    unsubSections();
    unsubRecs();
    removeScrollSpy();
    unsubCurrentSectionComponentEvent();
    unsubScrollToSection();

    if (unsubCurrentSection) {
      unsubCurrentSection();
    }
  });
</script>

<style style="text/scss" lang="scss">
  .column-current-section {
    position: sticky;
    z-index: 4;

    cursor: pointer;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.08);
    border-radius: 15px;
    padding-top: 14px;
    padding-bottom: 14px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.d-current-section {
      width: 110%;
      top: 5px;
      margin-left: -5%;

      img {
        width: 14px;
      }
    }

    &.m-current-section {
      width: 100%;
      top: 51px;
      background: white;
      position: fixed;
      left: 0;
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 17px;
      padding-bottom: 20px;
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
    }
  }

  .section-name {
    font-size: 15px;
    flex: 1;
    opacity: 0.5;
    word-break: break-word;
  }

  .section-recobjects-count {
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    margin-left: 10px;
    flex-shrink: 0;
    min-width: 24px;
    min-height: 24px;
    color: black;
    opacity: 0.5;
  }

  .section-active {
    align-items: center;

    .section-name {
      opacity: 1 !important;
      font-weight: 500 !important;
    }

    .section-recobjects-count {
      background: #a893f9 !important;
      color: white !important;
      opacity: 1 !important;
    }
  }

  * :global(.modal__overlay) {
    background: unset !important;
  }

  :global(.bottom-bar-visible) :global(.svelte-section-bar-modal) {
    bottom: 60px !important;
  }

  .current-section-dropdown-modal {
    margin: 0px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
</style>

{#if showSectionBar && currentSection}
  {#if currentSection}
    <div
      class:m-current-section={mobile}
      class:d-current-section={!mobile}
      class="column-current-section"
      on:click={toggleSectionMenu}>
      <div style="flex-shrink: 0; width: calc(100% - 90px)">
        {#if mobile}
          <div style="font-size: 13px; opacity: 0.5;">{group.name}</div>
        {/if}
        <div style="font-size: 15px; font-weight: 500; padding-top: 4px; word-break: break-word;">
          {currentSection.name}
        </div>
      </div>
      <div style="display: flex; align-items: center; flex-shrink: 0">
        {#if !showModal}
          <img src="/images/mobile/section-bar-up-arrow.svg" />
        {:else}
          <img src="/images/mobile/section-bar-down-arrow.svg" />
        {/if}
      </div>
    </div>
  {/if}

  <div class="svelte-modal svelte-section-bar-modal">
    <Modal
      style="position: absolute !important;"
      class="current-section-dropdown-modal"
      mobile={true}
      bind:show={showModal}
      showCloseButton={false}
      fadeInDuration={200}>
      <div slot="content" use:setStyleForCurrentSectionModal>
        <div style="display: flex; align-items: center; cursor: pointer;" on:click={toggleSectionMenu}>
          <div style="flex: 1; font-size: 13px; line-height: 16px; font-weight: 500" />
          <div style="flex-shrink: 0;">
            <img src="/images/mobile/section-bar-down-arrow.svg" style="width: 14px;" />
          </div>
        </div>

        <div>
          {#each sections.sortBy((x) => x.position) as section}
            <div
              style="display: flex; margin-top: 22px; cursor: pointer;"
              on:click|preventDefault|stopPropagation={() => {
                showModal = false;
                scrollToSection(section);
              }}
              class:section-active={currentSection && currentSection.id == section.id}>
              <div class="section-name">{section.name}</div>
              <div class="section-recobjects-count">
                {[...new Set(recs.where({ section_id: section.id }).map((x) => x.rec_object_id))].length}
              </div>
            </div>
          {/each}
        </div>
      </div>
      <div style="height: 100px">&nbsp;</div>
    </Modal>
  </div>
{/if}
